import structuredClone from '@ungap/structured-clone';
import moment from "moment";
import {mapGetters, mapMutations} from "vuex";

export default {
  data: () => ({
    mortgageId: null,
    applicant: null,
    coApplicant: null,
    responseData: {
      DTI: 0,
      sideIncome: 0,
      incomes: {
        applicant: [],
        coApplicant: []
      },
      banks: []
    },
    fullfilling: false,
    incomeToUpdate: null,

    initializingData: false,

    //google client
    client: null,

    banks: [],
  }),
  methods: {
    ...mapMutations({
      setApplicant: "setApplicant"
    }),

    // handleSignInClick() {
    //     this.client.grantOfflineAccess().then(response => {
    //         // Send the code to your backend to exchange for access token
    //         console.log(response.code);
    //     }).catch(error => {
    //         console.error(error);
    //     });
    // },
    async addClient() {
      if (!this.applicant) {
        const response = await this.$axios.post("auth/temp-client/", {
          auto_login: true
        });

        this.$store.commit("setRefresh", response["refresh_token"]);

        await this.setClientData();

        this.$store.commit("setClientId", this.applicant.id);
        this.$store.commit("initIsCompleted");
      }
    },

    async sendDataToGTM(e) {
      // {
      //     "prva_analyza_ciel_dt": "2022-12-06T10:53:23.492Z",
      //     "prva_analyza_pridany_prijem_dt": "2022-12-06T10:53:23.492Z",
      //     "prva_analyza_vypocitane_dti_dt": "2022-12-06T10:53:23.492Z",
      //     "prva_analyza_registracia_dt": "2022-12-06T10:53:23.492Z",
      // }
      const sendDt = async (dt) => {
        if (!this.applicant.mortgages[0][dt])
          await this.$axios.patch(`mortgage/${this.mortgageId}/`, {
            [dt]: new Date()
          });
      }

      window.dataLayer = window.dataLayer || [];

      //tu sa setuju aj klient data
      await this.setDti();

      switch (e) {
        case "ucel_vyber":
          await sendDt("prva_analyza_ciel_dt");
          break;
        case "prijem_pridany":
          await sendDt("prva_analyza_pridany_prijem_dt");
          break;
        case "dti_vypocitane":
          await Promise.all([sendDt("prva_analyza_vypocitane_dti_dt"), this.$axios.patch(`client-profile/${this.applicant.client_profile.id}/`, {
            prva_analyza_vypocitane_dti: this.responseData.DTI,
          })]);
          break;
        case "registracia_dokoncena":
          await sendDt("prva_analyza_registracia_dt");
          break;
      }

      if (e === "dti_vypocitane")
        e = "dti_zmenene";

      if (e !== "prijem_pridany") {
        const data = {
          event: e,
          purpose: this.applicant["mortgages"][0]["ciel_prva_analyza"],
          dti: this.responseData.DTI,
        }

        window.dataLayer.push(data);
      }
    },

    async afterInit() {
      this.fullfilling = true;

      //Načítanie predchádzajúceho formu v prípade, že klient už formom prechádzal
      try {
        //Robím to rekurentene, aby sme nenahradzovali celé objekty, ale skor ich doplnili o špecifikované hodnoty
        Object.entries(this.applicant["client_profile"]["meta"]["current_form_status"]).forEach(entry => {
          if (entry[1] !== null && entry[0] !== "formData")
            this[entry[0]] = entry[1];
          else if (entry[0] === "formData" && typeof entry[1] === "object")
            Object.entries(entry[1]).forEach(entry => {
              if (entry[1] !== null && entry[0] !== "dietaLastMonths")
                this.formData[entry[0]] = entry[1];
            });
        });
      }// eslint-disable-next-line no-empty
      catch {
      }

      this.loadData();

      this.fullfilling = false;
    },

    //POZOR: metoda pracuje s aktualnymi datami klienta. Pred použitim treba zavolat setClientData
    loadData() {
      const mortgage = this.applicant["mortgages"][0];

      //Mortgage
      if (mortgage) {
        Object.keys(this.formData.mortgage).forEach(key => {
          this.$set(this.formData.mortgage, key, mortgage[key]);
        });

        if (["nadobudnutie", "americka_hypo"].includes(mortgage.ciel_prva_analyza))
          this.$set(this.formData, "propertyValue", this.formData.mortgage[`suma_${mortgage.hlavny_ucel}`] + this.formData.mortgage.own_funds);
      }
    },
    async addCoApplicant() {
      this.coApplicant = (await this.$axios.post("auth/temp-client/")).data;

      this.sendDataToGTM("spoluziadatel_pridany").catch();

      await this.$axios.patch(`mortgage/${this.mortgageId}/`, {
        coapplicant: this.coApplicant.id
      });
    },

    async setClientData() {
      let mortgageCreated = false;

      this.applicant = (await this.$axios.get("client/me/?expand=client_profile,incomes,incomes.mesacne_prijmy,debts,mortgages,mortgages.applications")).data;

      this.setApplicant(this.applicant);

      if (!this.applicant.financnik)
        await this.$axios.patch(`client/${this.applicant.id}/`, {
          financnik: this.getBroker(window.location.origin)
        }).catch(e => console.log(e));

      if (!this.applicant.client_profile.origin)
        await this.$axios.patch(`client-profile/${this.applicant.client_profile.id}/`, {
          origin: window.location.origin
        });

      // const properties = (await this.$axios.get(`property/?created_by=${this.applicant.id}`)).data;

      //Vytvorenie mortgage, ak neexistuje
      if (!this.applicant["mortgages"].length) {
        mortgageCreated = true;

        const mortgage = (await this.$axios.post("mortgage/", {
          applicant: this.applicant.id,
          poznamka_k_prvej_analyze: window.location.origin
        })).data;

        this.mortgageId = mortgage.id;

        this.applicant.mortgages.push(mortgage);
      } else
        this.mortgageId = this.applicant["mortgages"][0].id;


      if (!mortgageCreated && this.applicant["mortgages"][0].coapplicant)
        this.coApplicant = (await this.$axios.get(`client/${this.applicant["mortgages"][0].coapplicant}/?expand=client_profile,incomes,incomes.mesacne_prijmy,debts,mortgages,mortgages.applications`)).data;

      //Aby sme preskočili screen na state 3(Aký je vas hl. zdroj prijmu)
      if (this.applicant.incomes.length) {
        this.form[0].next = 18;
        this.form[1].next = 18;
        this.form[2].next = 18;
      }
    },

    async setMortgageData() {
      let data = structuredClone(this.formData.mortgage);

      if (Object.keys(this.firstQuestionDisabledOrigins).includes(window.location.origin)) {
        data.ciel_prva_analyza = this.firstQuestionDisabledOrigins[window.location.origin].purpose;
        data.hlavny_ucel = this.firstQuestionDisabledOrigins[window.location.origin].purpose;
      }

      const promises = [];

      const financedProps = this.applicant.mortgages[0].financovane_nehnutelnosti;

      if (data.ciel_prva_analyza !== "nadobudnutie") {
        if (financedProps.length) {
          promises.push(this.$axios.delete(`property/${financedProps[0]}/`));
          data.financovane_nehnutelnosti = [];
          data.zakladane_nehnutelnosti = [];
        }

        data.own_funds = 0;
        data.suma_nadobudnutie = 0;
      } else {
        data.suma_nadobudnutie = Math.round(this.formData.mortgage.suma_nadobudnutie);
        data.own_funds = Math.round(this.formData.mortgage.own_funds);

        if (financedProps.length)
          promises.push(this.$axios.patch(`property/${financedProps[0]}/`, {
            hodnota: Math.round(this.formData.propertyValue)
          }));
        else {
          const prop = (await this.$axios.post("property/", {
            hodnota: Math.round(this.formData.propertyValue)
          })).data;

          //Po starom sme to davali ako financovanu nh
          // data.financovane_nehnutelnosti = [prop.id];
          data.financovane_nehnutelnosti = [];
          data.zakladane_nehnutelnosti = [prop.id];
        }
      }

      if (!["refinancovanie", "konsolidacia"].includes(data.ciel_prva_analyza)) {
        if (this.applicant["debts"].length)
          promises.push(this.$axios.delete(`client-debt/${this.applicant["debts"][0].id}/`));

        data.suma_refinancovanie = 0;
      } else {
        const debt = structuredClone(this.formData.debt);

        delete debt.temp;
        delete debt.meta;

        if (this.formData.debt.temp.den_splatky)
          debt.den_splatky = this.formData.debt.temp.den_splatky;
        if (this.formData.debt.temp.zaciatok)
          debt.zaciatok = this.formData.debt.temp.zaciatok;
        if (this.formData.debt.temp.suma)
          debt.povodna_suma = this.formData.debt.temp.suma;
        if (debt.zaciatok && debt.splatnost)
          debt.splatnost = moment(debt.zaciatok).add(debt.splatnost, "years").format("YYYY-MM-DD");

        //Koli zmene názvu parametru na BE
        debt.vyska_splatky = debt.splatka;
        delete debt.splatka;

        const payload = {
          typ: "hypoteka",
          ...debt
        }

        //Ak nemáme žiaden debt(v 1. analýze môže byť max 1 a to tento)
        if (!this.applicant["debts"].length) {
          payload.klient = this.applicant.id;
          payload.refinancovany_hypotekou = this.mortgageId;

          promises.push(this.$axios.post("client-debt/", payload));
        }
        //V prípade ak sa vrátime a updatujeme refinancovanie
        else
          promises.push(this.$axios.patch(`client-debt/${this.applicant["debts"][0].id}/`, payload));

        data.suma_refinancovanie = this.formData.debt.zostatok;

        if (this.formData.mortgage.ciel_prva_analyza === "konsolidacia")
          data.suma_refinancovanie += this.formData.debt.meta.orientacny_sucet;
      }

      const lienProps = this.applicant.mortgages[0].zakladane_nehnutelnosti;
      if (data.ciel_prva_analyza !== "americka_hypo") {
        data.suma_bezucel = 0;

        if (lienProps.length) {
          promises.push(this.$axios.delete(`property/${lienProps[0]}/`));
          data.zakladane_nehnutelnosti = [];
        }
      } else {
        if (lienProps.length)
          promises.push(this.$axios.patch(`property/${lienProps[0]}/`, {
            hodnota: Math.round(this.formData.propertyValue)
          }));
        else {
          const prop = (await this.$axios.post("property/", {
            hodnota: Math.round(this.formData.propertyValue)
          })).data;

          data.zakladane_nehnutelnosti = [prop.id];
        }

        data.suma_bezucel = Math.round(this.formData.mortgage.suma_bezucel);
      }

      promises.push(this.$axios.patch(`mortgage/${this.mortgageId}/`, data));

      await Promise.all(promises);
      await this.setClientData();
      this.sendDataToGTM("ucel_vyber").catch();
    },

    async getAverageIncome() {
      if (!this.collapsing && this.canContinue) {
        this.fullfilling = true;

        let payload;
        let apiPromise;

        switch (this.formData.income.mainIncome.druh) {
          case "trvaly_pracovny_pomer": {
            payload = [];

            this.formData.lastMonths.forEach(month => {
              if (month.value)
                payload.push({suma: month.value});
            });

            apiPromise = this.$axios.post("bank/calculations/dti-zamestnanie/", payload);
            break;
          }
          case "prijem_zivnostnika": {
            payload = structuredClone(this.formData.income.selfEmployed);

            payload.vydavky = payload["minulorocne_vydavky"];
            delete payload["minulorocne_vydavky"];

            if (this.formData.income.selfEmployed["pausalne_vydavky"] === "true") {
              payload["pausalne_vydavky"] = true;
              delete payload["vydavky"];
            } else
              delete payload["pausalne_vydavky"];

            if (this.formData.wayOfCalculatingPoistne === "yearly") {
              payload["rocne_poistne"] /= 12;
              payload["rocne_poistne"] = Math.round(payload["rocne_poistne"]);
            } else if (this.formData.wayOfCalculatingPoistne === "dont-know")
              payload["rocne_poistne"] = 0;

            apiPromise = this.$axios.post("bank/calculations/dti-szco/", payload);
            break;
          }
          case "prijem_z_sro":
            payload = structuredClone(this.formData.income.company);
            payload.vyplateny_zisk = payload.zisk;
            console.log(payload);
            apiPromise = this.$axios.post("bank/calculations/dti-sro/", payload);
            break;
        }

        const timerPromise = new Promise(resolve => {
          setTimeout(() => {
            resolve("Timer fullfilled");
          }, 500)
        });

        //Nech ESlint nemá problém, že nevie, akého typu je data
        let data = {};
        data = (await Promise.all([timerPromise, apiPromise]))[1].data;

        const values = [];

        Object.entries(data).forEach(entry => {
          if (entry[1]["success"])
            values.push(entry[1]["extra"]["prijem_mo"]);
        });

        this.fullfilling = false;

        this.formData.income.mainIncome.suma = Math.max(...values);
      } else
        this.formData.income.mainIncome.suma = 0;
    },
    // async getBanksForRent() {
    //     this.fullfilling = true;
    //
    //     const data = (await this.$axios.post("bank/calculations/dti-prenajom/", {suma: this.formData.income.sideIncome["prijem_z_prenajmu_nehnutelnosti"]})).data;
    //
    //     if (!this.banks.length) {
    //         const result = (await this.$axios.get("bank/")).data;
    //
    //         this.banks = result.results;
    //     }
    //
    //     this.responseData.banks = [];
    //
    //     Object.entries(data).forEach(entry => {
    //         const image = this.banks?.filter(bank => bank["code_name"] === entry[0])[0]["logo"];
    //
    //         this.responseData.banks.push({
    //             name: entry[0],
    //             value: entry[1].value ? `+${entry[1].value.toLocaleString()} EUR` : entry[1].details[0],
    //             image
    //         });
    //     });
    //
    //     console.log(this.responseData.banks)
    //
    //     this.fullfilling = false;
    // },
    async setMainIncomes() {
      const data = this.formData.income.mainIncome;

      const postMonths = async (incomeId) => {
        const monthlyIncomes = [];

        const lastMonthsClone = structuredClone(this.formData.lastMonths);

        if (this.formData.hasDiets)
          this.formData.dietaLastMonths.forEach(month => {
            if (month.value) {
              const monthRef = lastMonthsClone.filter(lMonth => month.date.getFullYear() === new Date(lMonth.date).getFullYear() && month.date.getMonth() === new Date(lMonth.date).getMonth())[0];

              if (monthRef)
                lastMonthsClone[lastMonthsClone.indexOf(monthRef)].travelExpenseValue = month.value;
              else {
                lastMonthsClone.push({
                  date: month.date,
                  travelExpenseValue: month.value,
                  value: 0
                });
              }
            }
          });

        lastMonthsClone.forEach(month => {
          const monthlyIncome = {};

          if (typeof month.date === "object") {
            monthlyIncome.rok = month.date.getFullYear();
            monthlyIncome.mesiac = month.date.getMonth() + 1;
          } else {
            const dateValues = month.date.split("-");

            monthlyIncome.rok = Number(dateValues[0]);
            monthlyIncome.mesiac = Number(dateValues[1]);
          }

          monthlyIncome.diety = month.travelExpenseValue ? month.travelExpenseValue : 0
          monthlyIncome.suma = month.value;
          monthlyIncomes.push(monthlyIncome);
        });


        //Ak Updatujeme income
        if (incomeId === this.incomeToUpdate) {
          const income = [...this.responseData.incomes.applicant, ...this.responseData.incomes.coApplicant].filter(income => income.id === id)[0];

          for (let i = 0; i < income["mesacne_prijmy"].length; i++)
            await this.$axios.delete(`client-monthly-income/${income["mesacne_prijmy"][i].id}/`);
        }

        for (let i = 0; i < monthlyIncomes.length; i++)
          await this.$axios.post("client-monthly-income/", {
            income: incomeId,
            ...monthlyIncomes[i]
          });
      }

      switch (data.druh) {
        case "prijem_zivnostnika": {
          const income = this.formData.income.selfEmployed;

          let rocnePoistne = 0;

          switch (this.formData.wayOfCalculatingPoistne) {
            case "yearly":
              rocnePoistne = income["rocne_poistne"];
              break;
            case "monthly":
              rocnePoistne = 12 * income["rocne_poistne"];
              break;
            case "dont-know":
              rocnePoistne = 0;
              break;
          }

          Object.assign(data, {
            minulorocny_obrat: income["trzby"],
            szco_rocne_poistne: rocnePoistne
          });

          if (income.pausalne_vydavky === "true")
            data.pausalne_vydavky = true;
          else
            data.minulorocne_vydavky = income["minulorocne_vydavky"];
          break;
        }
        case "prijem_z_sro": {
          const income = this.formData.income.company;

          Object.assign(data, {
            minulorocny_obrat: income.trzby,
            zisk_sro: income.zisk,
            podiel_v_sro: income.podiel,
            zamestnanie_od: "2022-01-01",
          });

          break;
        }
      }

      if (!this.formData.income.mainIncome.suma)
        await this.getAverageIncome();

      data["suma"] = Math.round(this.formData.income.mainIncome.suma);

      let id = this.incomeToUpdate;

      if (id)
        await this.$axios.patch(`client-income/${id}/`, data);
      else {
        data["client"] =
          this.formData.income.client === "applicant" ?
            this.applicant.id :
            this.coApplicant.id;

        id = (await this.$axios.post("client-income/", data)).data.id;
      }

      if (data.druh === "trvaly_pracovny_pomer")
        await postMonths(id);

      this.incomeToUpdate = null;

      await this.setClientData();
    },
    async setSideIncomes() {
      const payloads = [];

      if (this.formData.income.sideIncome.materska_rodicovsky_prispevok)
        await this.getMaterskaAmount();

      Object.entries(this.formData.income.sideIncome).forEach((entry, index) => {
        let obj = null;

        //index > 0: Nechceme mať v iterácií sideIncomeStates
        if (index > 0 && entry[1])
          obj = {
            druh: entry[0],
            suma: entry[1],
            typ: "vedlajsi",
          }

        if (obj) {
          obj.client = this.formData.income.client === "applicant" ? this.applicant.id : this.coApplicant.id;

          if (entry[0] === "prijem_z_prenajmu_nehnutelnosti")
            obj.zamestnanie_od = `${this.formData.income.incomeFrom.getFullYear()}-${this.formData.income.incomeFrom.getMonth() + 1}-01`;


          payloads.push(obj);
        }
      });

      const promises = [];

      if (this.incomeToUpdate && typeof this.incomeToUpdate === "object") {
        if (this.incomeToUpdate.length > payloads.length) {
          const incomesToDelete = this.incomeToUpdate.splice(payloads.length);

          incomesToDelete.forEach(incomeToDelete => {
            promises.push(this.$axios.delete(`client-income/${incomeToDelete}/`));
          });
        } else if (this.incomeToUpdate.length < payloads.length) {
          const incomesToPost = payloads.splice(this.incomeToUpdate.length);

          incomesToPost.forEach(incomeToPost => {
            promises.push(this.$axios.post("client-income/", incomeToPost));
          });
        }
      }

      payloads.forEach((payload, index) => {
        if (this.incomeToUpdate) {
          if (typeof this.incomeToUpdate === "object")
            promises.push(this.$axios.patch(`client-income/${this.incomeToUpdate[index]}/`, payload));
          else
            promises.push(this.$axios.patch(`client-income/${this.incomeToUpdate}/`, payload));

        } else
          promises.push(this.$axios.post("client-income/", payload));
      });

      await Promise.all(promises);

      this.incomeToUpdate = false;

      await this.setClientData();
    },
    async saveState() {
      if (this.applicant)
        await this.$axios.patch(`client-profile/${this.applicant["client_profile"].id}/`, {
          meta: {
            current_form_status: {
              formData: this.formData,
              state: this.state,
              history: this.history,
              seenSideIncomeOptions: this.seenSideIncomeOptions,
              incomeToUpdate: this.incomeToUpdate,
            }
          }
        });
    },
    async trigger2fa() {
      this.$v.formData.user.telephone.$touch();

      if (this.$v.formData.user.telephone.$error) {
        this.errMsg = "Telefónne číslo nie je v správnom tvare.";
        this.$bvModal.show("error-modal");
        //Redirectneme na 28. state
        this.state = 28;
        return;
      }

      let telephone = this.formData.user.telephone;
      telephone = `+421${telephone.substring(1)}`;

      try {
        await this.$axios.patch(`client-profile/${this.applicant["client_profile"].id}/`, {
          telephone,
        });
      } catch (e) {
        this.errMsg = "Nepodarilo sa uložiť telefónne číslo. ";
        if(e.response.data?.telephone?.[0]) {
          this.errMsg += e.response.data.telephone[0];
        }
        this.$bvModal.show("error-modal");
        //Redirectneme na 28. state
        this.state = 28;
        return;
      }

      try {
        await this.$axios.post(`client/${this.applicant.id}/create-twilio-verification/`, {
          telephone
        });
      } catch (e) {
        this.errMsg = "Nepodarilo sa odoslať overovací kód.";
        this.$bvModal.show("error-modal");
        //Redirectneme na 28. state
        this.state = 28;
      }
    },
    async verify2fa(code) {
      if(code.length !== 6) return;

      try {
        await this.$axios.post(`client/${this.applicant.id}/verify-twilio/`, {
          code
        });

        this.$bvModal.show("2fa-success-modal");
        this.state = 17;
        this.history.pop();
        this.form[16].next = 17;
      } catch (e) {
        this.errMsg = "Nepodarilo sa overiť kód.";
        this.$bvModal.show("error-modal");
      }
    },
    async register(code) {
      Object.keys(this.$v.formData.user).forEach(key => {
        if (!key.includes("$"))
          this.$v.formData.user[key].$touch();
      });

      // if (this.isPasswordValid.valid && !this.$v.$invalid) {
        this.fullfilling = true;

        try {
          const data = (await this.$axios.put("auth/temp-client/", {
            code
          })).data;

          this.$store.commit("setRefresh", data["refresh_token"]);

          await this.$axios.patch(`client-profile/${this.applicant["client_profile"].id}/`, {
            meta: null,
          });

          this.$bvModal.show("success-modal");

          this.sendDataToGTM("registracia_dokoncena").catch();

          //setujeme to preto až v registrácií, aby sme predišli meneniu účelu v 1. analyze predtým než ju klient nebude môcť pouźívať(zaregistruje sa)
          if (!this.applicant.mortgages[0]["hlavny_ucel"])
            await this.$axios.patch(`mortgage/${this.applicant["mortgages"][0].id}/`, {
              [`suma_${this.formData.mortgage.hlavny_ucel}`]: this.responseData.DTI,
            });
        } catch (e) {
          this.errMsg = "";

          Object.values(e.response.data).forEach(value => {
            if(Array.isArray(value)) {
              value.forEach(err => {
                this.errMsg += `${err}.`;
              });
            } else {
              this.errMsg += `${value}.`;
            }
          });

          this.$bvModal.show("error-modal");
        }

        this.fullfilling = false;
      // } else {
      //   this.errMsg = "";
      //
      //   if (!this.isPasswordValid.length)
      //     this.errMsg += "Heslo musí obsahovať aspoň 8 znakov.";
      //   if (!this.isPasswordValid.hasCapital)
      //     this.errMsg += "Heslo musí obsahovať aspoň 1 veľké písmeno.";
      //   if (!this.isPasswordValid.hasSmall)
      //     this.errMsg += "Heslo musí obsahovať aspoň 1 malé písmeno.";
      //   if (!this.isPasswordValid.hasNumber)
      //     this.errMsg += "Heslo musí obsahovať aspoň 1 číslo.";
      //   if (this.$v.formData.user.password2.$error && !this.$v.formData.user.password2.sameAsPassword)
      //     this.errMsg += "Heslá sa nezhodujú."
      //   if (this.$v.formData.user.email.$error && !this.$v.formData.user.email.email)
      //     this.errMsg += "Email nie je v správnom tvare.";
      //
      //   this.$bvModal.show("error-modal");
      // }
    },
    parseIncomes(incomes) {
      const pensions = incomes.filter(income => income.druh.includes("dochodca"));
      incomes = incomes.filter(income => !income.druh.includes("dochodca"));

      let pensionSum = 0;
      let pensionIds = [];

      pensions.forEach(pension => {
        pensionSum += pension.suma;
        pensionIds.push(pension.id);
      });

      if (pensions.length)
        incomes.push({
          druh: "dochodca",
          typ: "vedlajsi",
          suma: pensionSum,
          id: pensionIds
        });

      return incomes;
    },
    async setDti() {
      await this.setClientData();

      const promises = [
        this.$axios.post(`bank/calculations/client-dti/${this.applicant.id}/`),
      ];

      if (this.coApplicant)
        promises.push(this.$axios.post(`bank/calculations/client-dti/${this.coApplicant.id}/`));

      const responses = await Promise.all(promises);

      const getMax = (response) => {
        const values = [];

        Object.entries(response).forEach(entry => {
          values.push(entry[1].extra.dti_incomes);
        });

        return Math.max(...values);
      }

      this.responseData.DTI = getMax(responses[0].data);

      if (this.coApplicant)
        this.responseData.DTI += getMax(responses[1].data);
    },
    async getMaterskaAmount() {
      this.fullfilling = true;

      const vars = (await this.$axios.get("bank/vars/")).data;

      if (this.formData.materska)
        this.formData.income.sideIncome.materska_rodicovsky_prispevok = vars["rodicovsky_prispevok_ak_materska"];
      else
        this.formData.income.sideIncome.materska_rodicovsky_prispevok = vars["rodicovsky_prispevok_ak_nie_materska"];

      this.fullfilling = false;
    },
  },
  computed: {
    ...mapGetters({
      applicantStore: "getApplicant",
    }),

    debtTemp() {
      //Toto je koli Chat.vue - aby nehadzalo error, lebo tam nieje formdata
      if (!this.formData) return null;

      return `${this.formData.debt.temp.zaciatok}|${this.formData.debt.temp.suma}|${this.formData.debt.temp.den_splatky}|${this.formData.debt.splatnost}`;
    },
  },

  watch: {
    async state(to, from) {
      if (!this.applicant && this.applicantStore)
        this.applicant = this.applicantStore;

      if (!this.initializingData || [16, 17].includes(to)) {
        switch (to) {
          case 3:
            if ([0, 1, 23, 25, 26, 27].includes(from)) {
              if (!this.applicantStore)
                await this.addClient();

              this.formData.income.client = "applicant";
              await this.setMortgageData();
            }
            break;
          case 11:
            if (from === 7)
              this.seenSideIncomeOptions = true;
            break;
          case 16: {
            this.fullfilling = true;

            await this.sendDataToGTM("dti_vypocitane");

            Object.keys(this.formData.mortgage).forEach(key => {
              this.formData.mortgage[key] = this.applicant.mortgages[0][key]
            });

            this.fullfilling = false;
            break;
          }
          case 18:
            this.fullfilling = true;

            if (from === 11)
              this.seenSideIncomeOptions = true;

            //Ak sa dostaneme na 18 - čiže managera príjmov, nechcem do historie zahrňovať predošlé pages v príjmoch
            if (!this.history[1])
              this.history = [0]
            else
              this.history = [0, this.history[1]];


            if ([0, 1, 23, 25, 26, 27].includes(from)) {
              await this.setMortgageData();
            } else if ([5, 6, 9, 10, 19, 21].includes(from)) {
              await this.setMainIncomes();

              this.sendDataToGTM("prijem_pridany").catch();

              if (["prijem_zivnostnika", "prijem_z_sro"].includes(this.formData.income.mainIncome.druh))
                this.sendDataToGTM("podnikanie_prijem").catch();

              await this.resetFormData();
              this.sendDataToGTM("dti_zmenene").catch();
            } else if ([12, 13, 14, 15, 20, 22].includes(from)) {
              await this.setSideIncomes();
              await this.resetFormData();
              this.sendDataToGTM("dti_zmenene").catch();
            }

            this.fullfilling = false;
            break;
          case 19:
            if (from === 0)
              this.updateIncome(this.incomeToUpdate);
            break;
          case 22:
            await this.getMaterskaAmount();
            break;
          case 27:

            break;
        }

        await this.saveState();
      }
    },

    async debtTemp() {
      this.fullfilling = true;

      if (this.formData.debt.temp.zaciatok && this.formData.debt.temp.suma && this.formData.debt.temp.den_splatky) {
        this.formData.debt.temp.mesiace = this.formData.debt.splatnost * 12;

        this.formData.debt.temp.zaciatok = new Date(this.formData.debt.temp.zaciatok);
        this.formData.debt.temp.zaciatok = `${this.formData.debt.temp.zaciatok.getFullYear()}-${this.formData.debt.temp.zaciatok.getMonth() + 1}-01`;

        const p1 = this.$axios.post("bank/calculations/loan/", {
          ...this.formData.debt.temp,
          sadzba: this.formData.debt.sadzba
        });

        const p2 = new Promise(res => {
          setTimeout(() => {
            res();
          }, 1000);
        });

        const data = (await Promise.all([p1, p2]))[0].data;
        this.formData.debt.zostatok = Math.round(data.zostatok);
      }

      this.fullfilling = false;
    },

    "formData.debt.zostatok"(to) {
      if (to) {
        if (this.formData.mortgage.ciel_prva_analyza === "refinancovanie")
          if (this.applicant.incomes.length)
            this.form[this.state].next = 18;
          else
            this.form[this.state].next = 3;
        else if (this.formData.mortgage.ciel_prva_analyza === "konsolidacia")
          this.form[this.state].next = 27;
      } else
        this.form[25].next = 26;
    },

    "formData.mortgage.ciel_prva_analyza"(to) {
      if (to === "konsolidacia") {
        if (this.formData.debt.zostatok)
          this.form[25].next = 27;
        else
          this.form[26].next = 27;
      } else if (to === "refinancovanie") {
        if (this.formData.debt.zostatok)
          if (this.applicant.incomes.length)
            this.form[25].next = 18;
          else
            this.form[25].next = 3;
        else {
          if (this.applicant.incomes.length)
            this.form[26].next = 18;
          else
            this.form[26].next = 3;
        }
      }
    },

    applicant() {
      this.responseData.incomes.applicant = this.parseIncomes(this.applicant.incomes);
    },
    coApplicant() {
      this.responseData.incomes.coApplicant = this.parseIncomes(this.coApplicant.incomes);
    },
    // "formData.income.sideIncome.prijem_z_prenajmu_nehnutelnosti"(to) {
    //     this.fullfilling = true;
    //
    //     //TODO: možno refactor koli optimalizacii ?
    //     setTimeout(async () => {
    //         if (to === this.formData.income.sideIncome.prijem_z_prenajmu_nehnutelnosti) {
    //             await this.getBanksForRent();
    //
    //             this.fullfilling = false;
    //         }
    //     }, 1000);
    // }
  }
}